<template>
  <h2 v-if="props.title" class="h4">
    {{ props.title }}
    <Symbol
      v-if="props.symbolMessage" :symbol-message="props.symbolMessage" accessibility-id="pdfinformation"
      type="help" />
  </h2>
  <div class="pdf-view bg-color--gray-5">

    <div class="pdf-view__container">
      <div class="pdf-view__tools d-none">
        <button class="btn btn-tranparent pdf-view__icon" type="button">
          <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z" />
          </svg>
          <span class="sr-only">Expandera</span>
        </button>
        <button class="btn btn-tranparent pdf-view__icon" type="button">
          <svg viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z" />
          </svg>
          <span class="sr-only">Ladda ner</span>
        </button>
        <button class="btn btn-tranparent pdf-view__icon" type="button">
          <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z" />
          </svg>
          <span class="sr-only">Skriv ut</span>
        </button>
      </div>
      <iframe v-if="props.path !== ''" :src="props.path" type="application/pdf" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from "vue";
import Symbol from "../components/Symbol.vue";

export default defineComponent({
  name: "PDFView",
  components: {
    Symbol
  },
  props: {
    title: String,
    symbolMessage: String,
    path: {
      type: String,
      default: ""
    },
    data: {
      name: String,
      url: String
    }
  },

  setup(props) {
    const state = reactive({});

    return {
      state,
      props
    };
  }
});

</script>

<style lang="scss">
.pdf-view {
  margin-bottom: 24px;

  &__container {
    position: relative;
    width: 100%;
    min-height: 40vh;

    iframe {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      padding: 0.4rem;
      border: 0.125rem solid var(--spsm-gray-1);

      &:focus {
        outline: 0.188rem solid #0c5674;
      }
    }
  }

  &__tools {
    position: absolute;
    right: 0.4rem;
    top: 0.4rem;
    z-index: 10;
  }

  &__icon {
    margin-bottom: 0;
    padding: 0.6rem;
    width: 2.875rem;
    height: 2.875rem;

    &:hover {
      background: var(--spsm-red-1);

      &:focus {
        box-shadow: none;
      }

      svg {
        fill: #fff;
      }
    }

    svg {
      width: 1rem;
    }
  }
}
</style>
